@charset "UTF-8";
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]){
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*){
  pointer-events: none;
}

:host([hidden]){
  display: none;
}

[hidden]{
  display: none;
}

.scale--s{
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
  --calcite-combobox-item-spacing-unit-l: 0.5rem;
  --calcite-combobox-item-spacing-unit-s: 0.25rem;
  --calcite-combobox-item-spacing-indent: 0.5rem;
  --calcite-combobox-item-selector-icon-size: 1rem;
  --calcite-internal-combobox-item-description-font-size: var(--calcite-font-size-xs);
}

.scale--m{
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  --calcite-combobox-item-spacing-unit-l: 0.75rem;
  --calcite-combobox-item-spacing-unit-s: 0.375rem;
  --calcite-combobox-item-spacing-indent: 0.75rem;
  --calcite-combobox-item-selector-icon-size: 1rem;
  --calcite-internal-combobox-item-description-font-size: var(--calcite-font-size-sm);
}

.scale--l{
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  --calcite-combobox-item-spacing-unit-l: 1rem;
  --calcite-combobox-item-spacing-unit-s: 0.625rem;
  --calcite-combobox-item-spacing-indent: 1rem;
  --calcite-combobox-item-selector-icon-size: 1.5rem;
  --calcite-internal-combobox-item-description-font-size: var(--calcite-font-size);
}

.container {
  --calcite-combobox-item-indent-value: calc(
    var(--calcite-combobox-item-spacing-indent) * var(--calcite-combobox-item-spacing-indent-multiplier)
  );
}

:host(:focus){
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host,
ul{
  margin: 0px;
  display: flex;
  flex-direction: column;
  padding: 0px;
}

:host(:focus),
ul:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.label{
  position: relative;
  box-sizing: border-box;
  display: flex;
  inline-size: 100%;
  min-inline-size: 100%;
  cursor: pointer;
  align-items: center;
  color: var(--calcite-color-text-3);
  text-decoration-line: none;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  outline-color: transparent;
  word-wrap: break-word;
  word-break: break-word;
  justify-content: space-around;
  gap: var(--calcite-combobox-item-spacing-unit-l);
  padding-block: var(--calcite-combobox-item-spacing-unit-s);
  padding-inline: var(--calcite-combobox-item-spacing-unit-l);
  padding-inline-start: var(--calcite-combobox-item-indent-value);
}

:host([disabled]) .label{
  cursor: default;
}

.label--selected{
  color: var(--calcite-color-text-1);
}
.label--selected .title{
  font-weight: var(--calcite-font-weight-medium);
}

.label--active{
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.label:hover,
.label:active{
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-1);
  text-decoration-line: none;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.icon{
  display: inline-flex;
  opacity: 0;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--calcite-color-border-1);
}

.icon--custom {
  margin-block-start: -1px;
  color: var(--calcite-color-text-3);
}

.icon--active{
  color: var(--calcite-color-text-1);
}

.icon--dot{
  display: flex;
  justify-content: center;
  min-inline-size: var(--calcite-combobox-item-selector-icon-size);
}

.icon--dot::before {
  text-align: start;
  content: "•";
}

.label--active .icon{
  opacity: 1;
}

.label--selected .icon{
  opacity: 1;
  color: var(--calcite-color-brand);
}

:host(:hover[disabled]) .icon{
  opacity: 1;
}

.filter-match {
  font-weight: var(--calcite-font-weight-bold);
  color: var(--calcite-color-text-1);
  background-color: var(--calcite-color-foreground-current);
}

.center-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-block: 0;
}

.description {
  font-size: var(--calcite-internal-combobox-item-description-font-size);
}

:host([selected]) .description,
:host(:hover) .description {
  color: var(--calcite-color-text-2);
}

.short-text {
  color: var(--calcite-color-text-3);
  white-space: nowrap;
}

.title {
  color: var(--calcite-color-text-1);
}

.title,
.description,
.short-text {
  line-height: var(--calcite-font-line-height-relative-snug);
}